import {DETAIL_ACCSSORIES, PRODUCT_DETAIL_ERROR} from './types';

export const accessoriesDetail = dataDetailProduct => async dispatch => {
  try {
    dispatch({
      type: DETAIL_ACCSSORIES,
      payload: dataDetailProduct,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_DETAIL_ERROR,
      payload: error.message,
    });
  }
};
